import { FormIPSubnetField } from '@ipfabric/ui-components/FormIPSubnetField/FormIPSubnetField';
import {
  type IPSubnetInputValue,
  type IPSubnetInputValueOrDraft,
  isIpSubnetInputValidValue,
} from '@ipfabric/ui-components/IPSubnetInput/IPSubnetInput.types';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { z } from 'zod';
import type { DiscoverySettingsObject } from '../../model/DiscoverySettingsObject';

export const ipSeedList: FormSnippet<
  DiscoverySettingsObject,
  { ipSeedList: IPSubnetInputValueOrDraft },
  { ipSeedList: IPSubnetInputValue }
> = {
  render: ({ form }) => (
    <FormIPSubnetField
      control={form.control}
      name='ipSeedList'
      label='Starting points for network discovery (optional)'
      description='If no seed information is specified, the discovery will begin from the IP Fabric appliance default gateway.'
    />
  ),
  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.ipSeedList = {
      ips: model.seedList ?? [],
    };
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.seedList ??= [];
    modelDraft.seedList = transformedValues.ipSeedList.ips;
  },
  schema: z.object({
    ipSeedList: z
      .custom<IPSubnetInputValueOrDraft>()
      .refine(isIpSubnetInputValidValue),
  }),
};
